import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Deferred } from '../../classes/deferred';
import { environment } from '../../environment';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter, InputConverter, NumberConverter } from '../../inputConverter';
import { GisToolsService } from '../../services/gis-tools.service';
import { BaseComponent } from '../base.component';
var Graphic;
var Point;
var WebMercatorUtils;
var googleMapsApiLoadCheckInterval = 25;
var googleMapsApiLoadCheckMax = 15000;
var StreetViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(StreetViewComponent, _super);
    function StreetViewComponent(_vcf, cdr, gisToolService) {
        var _this = _super.call(this, _vcf, true) || this;
        _this.cdr = cdr;
        _this.gisToolService = gisToolService;
        _this.setRms = function (rms) {
            _this.onRmsChange(rms);
        };
        _this.debounceTime = 500;
        _this.precision = 6;
        _this.autoPanMap = false;
        _this.openToDefaultLocation = true;
        _this.positionChange = new Subject();
        _this.arrowColorR = 40;
        _this.arrowColorG = 96;
        _this.arrowColorB = 144;
        _this.arrowPath = 'M192 320L0 576h128v128h128V576h128L192 320z';
        _this.arrowSize = '16px';
        _this.location = { latitude: 0, longitude: 0, heading: 0 };
        _this.rmsChangeFlag = true;
        _this.rmsDefaultOffset = '40'; // Try to find a SV image on the segment requested
        return _this;
    }
    Object.defineProperty(StreetViewComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            value ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreetViewComponent.prototype, "lat", {
        get: function () { return this._lat; },
        set: function (value) {
            if (this.active && value && value !== this._lat) {
                this.setStreetView(value, this.long, this.heading, this.pitch);
            }
            this._lat = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreetViewComponent.prototype, "long", {
        get: function () { return this._long; },
        set: function (value) {
            if (this.active && value && value !== this._long) {
                this.setStreetView(this.lat, value, this.heading, this.pitch);
            }
            this._long = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreetViewComponent.prototype, "heading", {
        get: function () { return this._heading; },
        set: function (value) {
            if (this.active && value && value !== this._heading) {
                this.setStreetView(this.lat, value, this.heading, this.pitch);
            }
            this._heading = value;
        },
        enumerable: true,
        configurable: true
    });
    StreetViewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.loadGoogleMapScript(), this.loadESRIClasses()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StreetViewComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.mapViewRef) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.lat && this.long && this.openToDefaultLocation) {
                            this.setStreetView(this.lat, this.long, this.heading, this.pitch);
                        }
                        this.streetViewHandler = this.mapViewRef.on('click', this.onMapClick.bind(this));
                        this.resizeObserver = new ResizeObserver(function (entries) {
                            var e_1, _a;
                            try {
                                for (var entries_1 = tslib_1.__values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                                    var entry = entries_1_1.value;
                                    if (entry.target === _this.streetView.nativeElement && _this.panorama) {
                                        google.maps.event.trigger(_this.panorama, 'resize');
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        });
                        this.resizeObserver.observe(this.streetView.nativeElement);
                        this._active = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    StreetViewComponent.prototype.deactivate = function () {
        if (this.streetViewHandler) {
            this.streetViewHandler.remove();
        }
        if (this.arrowGraphic) {
            this.mapViewRef.graphics.remove(this.arrowGraphic);
        }
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.streetView.nativeElement);
        }
        this._active = false;
    };
    StreetViewComponent.prototype.onMapClick = function (event) {
        var geographicPoint = WebMercatorUtils.webMercatorToGeographic(event.mapPoint);
        this.setStreetView(geographicPoint.y, geographicPoint.x, this.heading, this.pitch);
    };
    StreetViewComponent.prototype.loadGoogleMapScript = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var script, deferred_1, apiChecks_1, apiCheckHandler_1;
            return tslib_1.__generator(this, function (_a) {
                if (!document.getElementById('MC-GoogleMapsApi') && !(window.google && window.google.maps)) {
                    if (!window.googleMapsApiCallback) {
                        window.googleMapsApiCallback = function () {
                            //console.log('Google Maps API loaded.')
                        };
                    }
                    script = document.createElement('script');
                    script.setAttribute('src', environment.googleMapApiUrl + "&" + environment.googleMapApiKey + "&callback=googleMapsApiCallback");
                    script.setAttribute('type', 'text/javascript');
                    script.setAttribute('id', 'MC-GoogleMapsApi');
                    document.head.appendChild(script);
                    deferred_1 = new Deferred();
                    apiChecks_1 = 0;
                    apiCheckHandler_1 = setInterval(function () {
                        apiChecks_1++;
                        if (apiChecks_1 > (googleMapsApiLoadCheckMax / googleMapsApiLoadCheckInterval)) {
                            clearInterval(apiCheckHandler_1);
                            deferred_1.reject();
                        }
                        else if (window.google && window.google.maps) {
                            clearInterval(apiCheckHandler_1);
                            deferred_1.resolve();
                        }
                    }, googleMapsApiLoadCheckInterval);
                    return [2 /*return*/, deferred_1.promise];
                }
                return [2 /*return*/];
            });
        });
    };
    StreetViewComponent.prototype.loadESRIClasses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!Graphic || !Point || !WebMercatorUtils)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.Point, ESRI.WebMercatorUtils])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), Graphic = _a[0], Point = _a[1], WebMercatorUtils = _a[2];
                        _b.label = 2;
                    case 2:
                        this.initializeStreetViewMarker();
                        return [2 /*return*/];
                }
            });
        });
    };
    StreetViewComponent.prototype.initializeStreetViewMarker = function () {
        if (!this.arrowSymbol) {
            var streetViewArrowColor = [this.arrowColorR, this.arrowColorG, this.arrowColorB];
            this.arrowSymbol = {
                type: 'simple-marker',
                color: streetViewArrowColor,
                size: this.arrowSize,
                path: this.arrowPath,
                angle: 0,
                outline: {
                    color: streetViewArrowColor,
                    width: 1
                }
            };
        }
    };
    StreetViewComponent.prototype.initializeGooglePanorama = function (position, pov) {
        this.panorama = new google.maps.StreetViewPanorama(this.streetView.nativeElement, {
            imageDateControl: true,
            position: position,
            pov: pov
        });
        this.panorama.addListener('position_changed', this.onStreetViewChange.bind(this));
        this.panorama.addListener('pov_changed', this.onStreetViewChange.bind(this));
        this.panorama.addListener('status_changed', this.onStreetViewStatusChange.bind(this));
    };
    StreetViewComponent.prototype.onRmsChange = function (rms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var offset, latLong;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!rms.offset || rms.offset === 0) {
                            rms.offset = this.rmsDefaultOffset;
                        }
                        offset = (rms.offset && rms.offset !== '0') ? rms.offset : this.rmsDefaultOffset;
                        return [4 /*yield*/, this.gisToolService.getLatLongForOffset(rms.countyCode, rms.stateRouteNumber, rms.segmentNumber, offset)];
                    case 1:
                        latLong = _a.sent();
                        if (latLong) {
                            this.rmsChangeFlag = false; // If RMS component sent the update, done have it refresh itself after navigation is done.
                            this.setStreetView(latLong.latitude, latLong.longitude, this.heading, this.pitch);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StreetViewComponent.prototype.setStreetView = function (latitude, longitude, heading, pitch) {
        if (heading === void 0) { heading = 0; }
        if (pitch === void 0) { pitch = 0; }
        if (latitude && longitude) {
            var position = new google.maps.LatLng(latitude, longitude);
            var pov = { heading: heading, pitch: pitch };
            this.location = { latitude: latitude, longitude: longitude, heading: heading };
            if (this.panorama) {
                var curPos = this.panorama.getPosition();
                var curPov = this.panorama.getPov();
                if (curPos.lat() !== latitude || curPos.lng() !== longitude) {
                    this.panorama.setPosition(position);
                }
                if (curPov.heading !== heading || curPov.pitch !== pitch) {
                    this.panorama.setPov(pov);
                }
            }
            else {
                this.initializeGooglePanorama(position, pov);
            }
            if (this.autoPanMap) {
                this.mapViewRef.goTo({
                    target: new Point(this.location),
                    animate: true
                });
            }
        }
    };
    StreetViewComponent.prototype.onStreetViewChange = function () {
        var position = this.panorama.getPosition();
        var pov = this.panorama.getPov();
        var heading = pov.heading;
        var latitude = position.lat();
        var longitude = position.lng();
        // This event fires multiple times per single update, wait until it actually changes to a new lat/long/heading before handling it
        if (!this.location || latitude !== this.location.latitude || longitude !== this.location.longitude || heading !== this.location.heading) {
            this.setStreetViewMarker(latitude, longitude, heading);
            this.positionChange.next({ latitude: latitude, longitude: longitude, heading: heading, rmsChangeFlag: this.rmsChangeFlag });
            this.location = { latitude: latitude, longitude: longitude, heading: heading };
            this.rmsChangeFlag = true;
        }
    };
    StreetViewComponent.prototype.onStreetViewStatusChange = function () {
        this.found = this.panorama.getStatus() === 'OK';
        this.panorama.setVisible(this.found);
        this.cdr.detectChanges();
    };
    StreetViewComponent.prototype.setStreetViewMarker = function (latitude, longitude, heading) {
        if (heading === void 0) { heading = 0; }
        this.markerGeometry = { type: 'point', latitude: latitude, longitude: longitude };
        this.arrowSymbol.angle = heading;
        if (this.arrowGraphic) {
            this.mapViewRef.graphics.remove(this.arrowGraphic);
        }
        this.arrowGraphic = new Graphic({
            geometry: this.markerGeometry,
            symbol: this.arrowSymbol
        });
        this.mapViewRef.graphics.add(this.arrowGraphic);
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], StreetViewComponent.prototype, "active", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], StreetViewComponent.prototype, "lat", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], StreetViewComponent.prototype, "long", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], StreetViewComponent.prototype, "heading", null);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], StreetViewComponent.prototype, "pitch", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], StreetViewComponent.prototype, "debounceTime", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], StreetViewComponent.prototype, "precision", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], StreetViewComponent.prototype, "autoPanMap", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], StreetViewComponent.prototype, "openToDefaultLocation", void 0);
    return StreetViewComponent;
}(BaseComponent));
export { StreetViewComponent };
